"use client";
import { useListingsCacheStore } from "@/global-cache/useListingsCacheStore";
import React from "react";

export function CacheWrapper({ children }: { children: React.ReactNode }) {
  const storeState = useListingsCacheStore();
  return <>{children}</>;
}
